import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createServiceCategory } from 'API/ServiceCategories/createServiceCategory';

const useCreateServiceCategory = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const create = async (serviceCategoryData) => {
        const response = await createServiceCategory(serviceCategoryData);
        return response.data;
    };

    return useMutation({
        mutationFn: create,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['ServiceCategories'] });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useCreateServiceCategory;
